import styled, { keyframes } from 'styled-components';
import {
  MdOutlineCircle,
  MdOutlineCheckCircleOutline,
  MdOutlineCancel,
  MdHistoryToggleOff,
} from 'react-icons/md';

export const StyledListItem = styled.div`
  width: 30%;
  height: 3rem;
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
  border: 1px solid #b2b2b2ff;
  border-radius: 15px;
`;

export const StyledLi = styled.li`
  padding: 0.5rem;
  color: #3a3a3aff;
`;

export const StyledUl = styled.ul`
  list-style-type: none;
  margin:0;
  padding:0;
`;

export const animationIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const StyledAnimationInDiv = styled.div`
  animation: ${animationIn} 1s linear;
`;

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
  font-size: 1.25rem;
`;

export const StyledCheckCircle = styled(MdOutlineCheckCircleOutline)`
  color: green;
`;

export const StyledOutlineCircle = styled(MdOutlineCircle)`
  color: #3a3a3aff;
`;

export const StyledOutlineCancel = styled(MdOutlineCancel)`
  color: #7c0f0fff;
`;

export const StyledInProgress = styled(MdHistoryToggleOff)`
  color: #e6b400;
`;